import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDescargar1 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 11,
	height: 12,
	viewBox: "0 0 11 12",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "descargar1",
		transform: "translate(9.732 3042.84)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path",
			d: "M9.429,0H8.25V.75H9.429a.769.769,0,0,1,.786.75V9a.769.769,0,0,1-.786.75H1.571A.769.769,0,0,1,.786,9V1.5A.769.769,0,0,1,1.571.75H2.75V0H1.571A1.537,1.537,0,0,0,0,1.5V9a1.537,1.537,0,0,0,1.571,1.5H9.429A1.537,1.537,0,0,0,11,9V1.5A1.537,1.537,0,0,0,9.429,0Z",
			transform: "translate(-9.732 -3041.34)",
			fill: "#131314"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path-2",
			"data-name": "Path",
			d: "M.115,7.034l2.71,2.587a.4.4,0,0,0,.3.106.4.4,0,0,0,.3-.106l2.71-2.587a.363.363,0,0,0,0-.531.407.407,0,0,0-.556,0L3.516,8.47V.375a.393.393,0,0,0-.786,0V8.47L.671,6.5a.406.406,0,0,0-.555,0,.363.363,0,0,0,0,.531Z",
			transform: "translate(-7.356 -3042.84)",
			fill: "#131314"
		})]
	})]
});
const ForwardRef = forwardRef(SvgDescargar1);
export { ForwardRef as ReactComponent };
